import { render, staticRenderFns } from "./APIUserTokensList.vue?vue&type=template&id=484b63a2&scoped=true&"
import script from "./APIUserTokensList.vue?vue&type=script&lang=js&"
export * from "./APIUserTokensList.vue?vue&type=script&lang=js&"
import style0 from "./APIUserTokensList.vue?vue&type=style&index=0&id=484b63a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b63a2",
  null
  
)

export default component.exports